"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _Empty = require("./Empty.style");

var _Button = _interopRequireDefault(require("../button/Button"));

var _excluded = ["text", "buttonProps", "iconName", "children"];

var Empty = function Empty(_ref) {
  var text = _ref.text,
      buttonProps = _ref.buttonProps,
      iconName = _ref.iconName,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Empty.StyledEmpty, props, children ? children : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, iconName && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: iconName,
    size: 50
  }), text && /*#__PURE__*/_react["default"].createElement(_Empty.StyledText, null, text), buttonProps && /*#__PURE__*/_react["default"].createElement(_Empty.StyledButton, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, buttonProps, {
    margin: "auto"
  })))));
};

Empty.defaultProps = {
  iconName: 'Greet'
};
Empty.propTypes = {
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  bg: _propTypes["default"].string,
  text: _propTypes["default"].string,
  buttonProps: _propTypes["default"].objectOf({
    children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    color: _propTypes["default"].string,
    variant: _propTypes["default"].string
  }),
  children: _propTypes["default"].element,
  iconName: _propTypes["default"].string
};
var _default = Empty;
exports["default"] = _default;